import {
  PackageIcon,
  DatabaseIcon,
  ChartBarLineIcon,
  UserMultipleIcon,
  NewsIcon,
  AddToListIcon,
  Archive02Icon,
  User03Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const FINANCE_NAV_ITEMS: NavItem[] = [
  { title: 'Purchase Orders', icon: PackageIcon, route: '/app/finance/purchase-orders' },
  {
    title: 'Sales Requests',
    icon: Archive02Icon,
    route: '/app/finance/sales-requests',
  },
  {
    title: 'Payment Vouchers',
    icon: DatabaseIcon,
    route: '/app/finance/payment-vouchers',
  },
  { title: 'Vendors', icon: UserMultipleIcon, route: '/app/finance/vendors' },
  { title: 'Quotations', icon: NewsIcon, route: '/app/finance/purchase-quotations' },
  {
    title: 'Purchase Requests',
    icon: AddToListIcon,
    route: '/app/finance/purchase-requests',
  },
  {
    title: 'Receipt Vouchers',
    icon: DatabaseIcon,
    route: '/app/finance/receipt-vouchers',
  },
  {
    title: 'General Journal',
    icon: ChartBarLineIcon,
    route: '/app/finance/general-journal',
  },
  {
    title: 'Installment Accounts',
    icon: Archive02Icon,
    route: '/app/finance/accounts',
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/finance/notifications',
  },
];
